<template>
  <div class="albumImg">
    <img :src="src" class="img" :style="`width: ${width}px; height: ${height}`">
    <img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/h5/bg/bg-album.png" class="bg-img mr-16">
  </div>
</template>

<script>
  export default {
    props: {
      src: {
        type: String
      },
      width: {
        type: String
      },
      height: {
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
.albumImg{
  display: flex;
  .img{
    width: 108px;
    height: 108px;
  }
  .bg-img{
    width: 10px;
    height: 100%;
  }
}
</style>
